import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { LearnedScreen } from "../../screens/home/Reveal.tsx";

/** `/learned`: what Adea learned about the company. */
export const Route = createFileRoute("/_app/learned")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("onboarding.get", {})),
  component: LearnedScreen,
});
